<template>
  <div class="technical-facts">
    <oie-base-accordion-toggler
      :is-open="isOpen"
      :text="tStatic('titleTechnicalFacts')"
      class="techinical-facts__toggler"
      @click="toggleAccordion()"></oie-base-accordion-toggler>

    <!-- :text="t('productDetailTechincalFacts')" -->

    <div :class="['technical-facts__content', { 'technical-facts__content--is-open': isOpen }]">
      <div class="grid grid--four techinical-facts__grid">
        <template v-for="(category, categoryName) in technicalData">
          <div :key="categoryName" class="property-container">
            <div class="property-container__header">
              {{ categoryName }}
            </div>

            <table class="property-table technical-facts__table">
              <tr v-for="key in sortedKeys(category)" :key="key" class="property-table__item">
                <td>
                  {{ key }}
                </td>

                <td>
                  {{ category[key] }}
                </td>
              </tr>
            </table>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    technicalData: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isOpen: false
  }),
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen
    },
    sortedKeys(category) {
      const keys = Object.keys(category)
      /* keys.sort() */
      return _.filter(keys, function(k) { return category[k] !== '-' })
    }
  }
}
</script>

<style lang="scss">
.technical-facts {
  margin-bottom: measure(double);
  padding: measure(quarter) 0;
  border-top: 1px solid color(border-gray);
  border-bottom: 1px solid color(border-gray);

  @include media(medium) {
    padding: measure(half) 0;
  }
}

.technical-facts__content {
  display: none;
  overflow: hidden;
}

.technical-facts__content--is-open {
  display: block;
}

.techinical-facts__grid {
  width: 100%;
  padding-top: measure(full);
  padding-bottom: measure(full);
}

.technical-facts__table {
  width: 100%;
  background-color: white;
}
</style>
